import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from 'src/app/components/auth/service/auth.service';
import { FundingSourceService } from 'src/app/services/app/fundingsource/funding-source.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { ManualPaymentService } from 'src/app/services/core/manual-payment/manual-payment.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { TripService } from 'src/app/services/core/trip/trip.service';
@UntilDestroy()

@Component({
  selector: 'app-trip-detail-modal',
  templateUrl: './trip-detail-modal.component.html',
  styleUrls: ['./trip-detail-modal.component.css']
})
export class TripDetailModalComponent implements OnInit, AfterViewInit {
  @Output() closeModal = new EventEmitter<any>
  @Input() tripId: any;
  tripDetail: any;
  appointmentType: any
  member: any;
  spacetypes: any;
  @ViewChild('map') map!: GoogleMap;
  events: any = [];
  fundingSource: any;
  serviceAreas: any;
  levelOfServices: any;
  addons: any;
  preAddons: any
  company: any;
  driver:any;
  vehicle:any;
  @Input() source: string = '';
  tripObservable: any;
  manualPayments: any = [];
  routeVisible = false;
  directions?: google.maps.DirectionsResult;
  straightPath: google.maps.LatLngLiteral[] = [];


  constructor(
    private appointmentTypeService: AppointmentTypeService,
    private memberService: MemberService,
    private spaceTypeService: SpaceTypeService,
    private authService: AuthService,
    private fundingSourceService: FundingSourceService,
    private credentialService: CredentialService,
    private serviceArea: ServiceAreasService,
    private levelOfService: LosService,
    private tripService: TripService,
    private addonService: AddonService,
    private billingService: BillingService,
    private manualPaymentService: ManualPaymentService,) {
  }

  ngOnInit(): void {
    this.getAllAddons()
    this.getTripById();
    this.getManualPayments();
  }

  ngAfterViewInit(): void {
    this.fitMapToBounds();
  }

  formatValue(value: any) {
    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'object' && value !== null) {
      return `Rate: ${value.fare ?? 'N/A'} From: ${value.from ?? ''} To: ${value.to ?? ''}`;
    } else {
      return 'N/A';
    }
  }


  getManualPayments() {
    if (this.source !== 'billing') {
      return;
    }
    this.manualPaymentService.getAll({ billing: this.tripId, limit: 9999, sortBy: 'createdAt:desc' })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.manualPayments = data.results;
        }
      });
  }

  getTripById() {

    if (this.source === 'billing') {
      this.tripObservable = this.billingService.getTripById(this.tripId);
    } else {
      this.tripObservable = this.tripService.getTripById(this.tripId);
    }

    this.tripObservable.pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.tripDetail = data;
        if (this.tripDetail?.pickup && this.tripDetail?.destination) {

          this.straightPath = [
            {
              lat: this.tripDetail.pickup.address.coords[1],
              lng: this.tripDetail.pickup.address.coords[0]
            },
            {
              lat: this.tripDetail.destination.address.coords[1],
              lng: this.tripDetail.destination.address.coords[0]
            }
          ];
        }
        this.getMembersById();
        this.getAppointmentById();
        this.getTripEvents();
        this.getSpaceTypes();
        this.getFundingSource();
        this.getAllCompanies();
        this.getServiceAreas();
        this.getLevelOfService();
        this.getDriverById();
        this.getVehicleById();
        // this.getAllAddons()
        setTimeout(() => this.fitMapToBounds(), 0);
      }
    });
  }


  getSortedBreakdown(fare: any, breakdown: any) {
    if (!breakdown) return [];

    const priority: Record<string, number> = {
      total: 0,
      baseFare: 1,
    };

    return Object.entries(breakdown)
      .flatMap(([key, value]) => {
        // Special case: flatten zone to show only its baseFare
        if (key === 'baseFare') {
          return [];
        }

        if (
          key.toLowerCase() === 'zone' &&
          value !== null &&
          typeof value === 'object' &&
          'baseFare' in value
        ) {
          return [{
            key: `Zone
            (from ${'from' in value ? value.from : ''} to ${'to' in value ? value.to : ''}mi)`,
            value: value.baseFare,
            unit: '$'
          }];
        }

        return [{
          key: this.formatKey(key),
          value,
          unit: this.getUnit(key, value, fare)
        }];
      })
      .sort((a, b) => {
        const orderA = a.key.replace(/\s+/g, '').toLowerCase() in priority ? priority[a.key.replace(/\s+/g, '').toLowerCase()] : 2;
        const orderB = b.key.replace(/\s+/g, '').toLowerCase() in priority ? priority[b.key.replace(/\s+/g, '').toLowerCase()] : 2;
        return orderA - orderB;
      });
  }

  private formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, char => char.toUpperCase());
  }

  private getUnit(key: string, value: any, fare: any): string {
    const lowerKey = key.toLowerCase();
    if (value === null) return '';

    // Explicit overrides
    const unitMap: Record<string, string> = {
      distance: 'mi',
      duration: 'min',
      from: 'mi',
      to: 'mi',
    };
    if (unitMap[lowerKey]) return unitMap[lowerKey];

    const moneyLikeKeys = [
      'basefare',
      'fare',
      'permilefare',
      'perminfare',
      'total',
      'waittimecharges',
      'pickupsurcharge',
      'extrapassengerfare',
      'additionalpassengers',
      'cancelcharges',
      'noshowcharges',
    ];
    if (moneyLikeKeys.includes(lowerKey)) return '$';

    if (fare?.type === 'percentage') return '%';
    if (fare?.type === 'fixed') return '$';

    return '';
  }

  fitMapToBounds() {
    const pickup = this.tripDetail?.pickup?.address?.coords;
    const dropoff = this.tripDetail?.destination?.address?.coords;

    if (!pickup || !dropoff || !this.map || !this.map.googleMap) return;

    const bounds = new google.maps.LatLngBounds();
    bounds.extend(new google.maps.LatLng(pickup[1], pickup[0]));
    bounds.extend(new google.maps.LatLng(dropoff[1], dropoff[0]));

    const gMap = this.map.googleMap;
    if (!gMap) return;

    gMap.fitBounds(bounds, 8);
    const mzoom: any = gMap.getZoom();
    gMap.setZoom(mzoom)
  }

  getServiceAreas() {
    this.serviceArea.getById(this.tripDetail.serviceArea).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.serviceAreas = data;
      }
    })
  }

  getTripEvents() {
    let queryParams:any
    if (this.source === 'billing'){
       queryParams = {
        billing: this.tripId
      };
    }else{
      queryParams = {
        trip: this.tripId
      };
    }
   
    this.tripService.getTripEvents(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
            this.events = data.results;
        }
    })
  }

  getMembersById() {
    this.memberService.getMemberById(this.tripDetail.member).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.member = data;
      }
    })
  }

  getAppointmentById() {
    this.appointmentTypeService.getAppointmentById(this.tripDetail.appointmentType).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.appointmentType = data;
      }
    })
  }

  getFundingSource() {
    this.fundingSourceService.getById(this.tripDetail.fundingsource).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.fundingSource = data;
      }
    })
  }

  getAllCompanies() {
    if (!this.tripDetail?.company) return;
    this.credentialService.getCompanyById(this.tripDetail.company).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.company = data;
      }
    });
  }

  getSpaceTypes() {
    this.spaceTypeService.getById(this.tripDetail.spaceType).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.spacetypes = data;
      }
    })
  }

  getLevelOfService() {
    this.levelOfService.getById(this.tripDetail.levelOfService).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.levelOfServices = data;
      }
    })
  }

  getDriverById() {
    if (!this.tripDetail?.driver) return;
    this.credentialService.getDriverById(this.tripDetail.driver).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.driver = data;
      }
    })
  }

  getVehicleById() {
      if (!this.tripDetail?.vehicle) return;
    this.credentialService.getVehicleById(this.tripDetail.vehicle).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.vehicle = data;
      }
    })
  }

  getAllAddons() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.addonService.getAddons(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.addons = data.results;
        this.preAddons = this.addons.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  loadDirections() {
    if (!this.tripDetail?.pickup || !this.tripDetail?.destination) return;

    const pickup = this.tripDetail.pickup.address.coords;
    const dropoff = this.tripDetail.destination.address.coords;

    const service = new google.maps.DirectionsService();

    service.route(
      {
        origin: { lat: pickup[1], lng: pickup[0] },
        destination: { lat: dropoff[1], lng: dropoff[0] },
        travelMode: google.maps.TravelMode.DRIVING,
        provideRouteAlternatives: true // get multiple routes
      },
      (result: any, status) => {
        if (status === 'OK' && this.routeVisible) {
          // 🔹 Pick the shortest route
          let shortestRoute = result.routes[0];
          let minDistance = result.routes[0].legs.reduce(
            (sum: number, leg: any) => sum + leg.distance.value,
            0
          );

          result.routes.forEach((route: any) => {
            const routeDistance = route.legs.reduce(
              (sum: number, leg: any) => sum + leg.distance.value,
              0
            );
            if (routeDistance < minDistance) {
              minDistance = routeDistance;
              shortestRoute = route;
            }
          });

          // Only assign the shortest route
          this.directions = {
            ...result,
            routes: [shortestRoute],
          };
        }
      }
    );
  }

  toggleRoute(checked: boolean) {
    this.routeVisible = checked;  // Set based on event
    if (this.routeVisible) {
      if (!this.directions) {
        this.loadDirections();
      }
    } else {
      this.fitMapToBounds();
    }
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
